import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { H1, translateNum } from '../const';
import { gameRank, LeaderBoardDetails, myScore } from '../services/ApiServices';

const Container = styled.div`
    border-radius: 20px;
    text-align: center;
    background: #fff;
    height: 469px;
    padding: 15px;

    h1 {
        font-size: 24px;
    }
`;

const Link = styled.li`
    margin: 10px 0;
    cursor: pointer;
    display: flex;
    width: 100%;
    justify-content: space-between;
    &.my-score {
        border: 3px solid #f8d760;
        border-radius: 5px;
        padding: 4px;
        margin-left: -5px;
        .my-score-title {
            margin-left: -2px;
        }
        .score {
            margin-right: 2px;
        }
    }
    p {
        font-size: 16px;
        font-family: 'Open Sans';
        font-weight: 700;
        margin: 5px 0;
    }
`;
const LoaderSection = styled.section`
    margin-left: 2px;
    .loader {
        position: relative;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        margin-top: -4px;
        .loader-outter {
            position: absolute;
            border: 2px solid #080915;
            border-left-color: transparent;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            animation: rotation infinite 0.7s linear;
        }
        @keyframes rotation {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    }
`;

function LeaderBoard({ gameId, token }) {
    const [leaderboardData, setLeaderboardData] = useState([]);
    const [scoreDetails, setScoreDetails] = useState();
    const [inTop, setInTop] = useState(false);
    const [userWalletAddress, setUserWalletAddress] = useState();
    const [myRank, setMyRank] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();

    const updateLeaderboard = () => {
        LeaderBoardDetails(gameId)
            .then((response) => {
                setLeaderboardData(response.data.data);
                token &&
                    myScore(gameId, token)
                        .then((res) => {
                            const result = res.data.data;
                            setScoreDetails(result);

                            if (result !== null) {
                                const walletAddress =
                                    res.data.data.userId.walletAddress;
                                setUserWalletAddress(walletAddress);
                                const filteredData = response.data.data
                                    .slice(0, 10)
                                    .filter(
                                        (data) =>
                                            data._id.walletAddress ===
                                            walletAddress
                                    );
                                if (filteredData.length !== 0) {
                                    setInTop(true);
                                } else {
                                    setIsLoading(true);
                                    gameRank(gameId, token)
                                        .then((res) => {
                                            setMyRank(res.data.data.rank);
                                            setIsLoading(false);
                                        })
                                        .catch((err) => {
                                            setIsLoading(false);
                                        });
                                    setInTop(false);
                                }
                            }
                        })
                        .catch((err) => err);
            })
            .catch((error) => error);
    };

    useEffect(() => {
        updateLeaderboard();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gameId, token]);

    const ScoreList = () => {
        return (
            <>
                <ul
                    style={{
                        listStyle: 'none',
                        padding: 0,
                        userSelect: 'none',
                    }}
                >
                    {leaderboardData?.length &&
                        leaderboardData.map((ele, i) =>
                            i < 9 ? (
                                <Link
                                    key={i}
                                    className={
                                        ele._id.walletAddress ===
                                            userWalletAddress && 'my-score'
                                    }
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            gap: '15px',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <p style={{ marginLeft: '7px' }}>
                                            {i + 1}.
                                        </p>
                                        {ele._id.walletAddress ===
                                        userWalletAddress ? (
                                            <p className='my-score-title'>
                                                {t('my_score')}
                                            </p>
                                        ) : (
                                            <p>
                                                {ele._id.walletAddress.slice(
                                                    0,
                                                    5
                                                )}
                                                ...
                                                {ele._id.walletAddress.slice(
                                                    ele._id.walletAddress
                                                        .length - 6,
                                                    ele._id.walletAddress.length
                                                )}
                                            </p>
                                        )}
                                    </div>
                                    <p
                                        className={
                                            ele._id.walletAddress ===
                                                userWalletAddress && 'score'
                                        }
                                    >
                                        {translateNum(ele.score)}
                                    </p>
                                </Link>
                            ) : (
                                ''
                            )
                        )}
                    {token && !inTop ? (
                        <Link className='my-score'>
                            <>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    {isLoading && (
                                        <LoaderSection>
                                            <div class='loader loader-1'>
                                                <div class='loader-outter'></div>
                                            </div>
                                        </LoaderSection>
                                    )}
                                    {
                                        myRank && (
                                            <p style={{ marginLeft: '6px' }}>
                                                {myRank}.
                                            </p>
                                        )
                                        // : <p style={{marginLeft:'4px',fontSize:'14px',fontWeight:600}}>NA</p>
                                    }
                                    <p
                                        className='my-score-title'
                                        style={{
                                            marginLeft: isLoading
                                                ? '17px'
                                                : myRank
                                                ? '14px'
                                                : '9px',
                                        }}
                                    >
                                        {t('my_score')}
                                    </p>
                                </div>
                                <p style={{ marginRight: '2px' }}>
                                    {scoreDetails?.score
                                        ? translateNum(scoreDetails?.score)
                                        : '0'}
                                </p>
                            </>
                        </Link>
                    ) : null}
                </ul>
            </>
        );
    };

    return (
        <Container>
            <H1 style={{ lineHeight: '20px', userSelect: 'none' }}>
                {t('leaderboard')}
            </H1>
            <div>{ScoreList()}</div>
            <button
                style={{ display: 'none' }}
                id='leaderboard_update'
                onClick={updateLeaderboard}
            ></button>
        </Container>
    );
}

export default LeaderBoard;
